module.exports = __webpack_public_path__ + "static/15-2-a9d3f5a5be3c9f0c473349d602e71c8d.jpg";